export default __webpack_public_path__ + "static/NuvemFiscalRodape1-d53848c5d639818c0dd59cad3f1e26fd.png";